import { useGraphQLMutation } from '@opengov/bnp-core';
import { useQueryClient } from '@tanstack/react-query';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  UpdateMenuTitleByIdForOnlinePublicationMutation,
  UpdateMenuTitleByIdForOnlinePublicationMutationVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import { setupOnlinePublicationQueryKeys } from './setupOnlinePublicationQueryKeys';

const UpdateMenuTitleByIdForOnlinePublicationDocument = graphql(`
  mutation UpdateMenuTitleByIdForOnlinePublication($id: uuid!, $title: String) {
    update_publicationNavigationMenuItems(
      where: { id: { _eq: $id } }
      _set: { title: $title }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`);

export type UseUpdateMenuTitleMessages = {
  successTitle: string;
  successBody?: string;
  errorTitle: string;
  errorBody?: string;
};

export type UseUpdateMenuTitleContext = {
  publicationId: string;
};

export function useUpdateMenuTitle(
  context: UseUpdateMenuTitleContext,
  messages: UseUpdateMenuTitleMessages
) {
  const queryClient = useQueryClient();
  const { toggleToast } = useToast();

  return useGraphQLMutation<
    UpdateMenuTitleByIdForOnlinePublicationMutation,
    UpdateMenuTitleByIdForOnlinePublicationMutationVariables
  >({
    mutationKey: [...setupOnlinePublicationQueryKeys.all, 'updateMenuTitle', context],
    document: UpdateMenuTitleByIdForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    options: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: setupOnlinePublicationQueryKeys.navigationMenus({
            publicationId: context.publicationId
          })
        });
        toggleToast({
          title: messages.successTitle,
          body: messages.successBody,
          severity: 'success'
        });
      },
      onError: () =>
        toggleToast({
          title: messages.errorTitle,
          body: messages.errorBody,
          severity: 'error'
        })
    }
  });
}
